import { render, staticRenderFns } from "./FieldWorkplaceTable.vue?vue&type=template&id=e70a119a&scoped=true&"
import script from "./FieldWorkplaceTable.vue?vue&type=script&lang=js&"
export * from "./FieldWorkplaceTable.vue?vue&type=script&lang=js&"
import style0 from "./FieldWorkplaceTable.vue?vue&type=style&index=0&id=e70a119a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70a119a",
  null
  
)

export default component.exports